export default {
  subscribeTodayForJust: {
    en: 'Subscribe today for just {subscriptionPrice}',
  },
}
